import React from "react";
import { Footer } from "./footer";
import { Navbar } from "./navbar";
import { Sidebar } from "./sidebar";

function BaseLayout(props) {
  
  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">{props.children}</div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export { BaseLayout };
